// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = require(116);
var $getPrototypeOf = require(92);

require(96)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});
